import PropTypes from "prop-types";

const DotIcon = props => {
  const { color = "#eb1202" } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <circle
        cx={50}
        cy={50}
        r={40}
        fill={color}
        fillOpacity="1"
        stroke="white"
        strokeWidth="6"
      />
    </svg>
  );
};

DotIcon.propTypes = {
  color: PropTypes.string,
};

export default DotIcon;
